/**
 * Routes candidate-results.
 *
 * @remarks
 * - `candidateResultsRoutes` : routes auth (`/user-tests`, `/user-tests/:id`)
 * - `candidateResultsPublicRoutes` : route publique partageable
 *   (`/tests/:tid/evaluation/:eid/attempt/:aid`) — accessible sans login.
 *
 * `Component: Outlet` sur chaque leaf : silence le warning React Router v7
 * "leaf route does not have an element". L'AppShell rend déjà tout via le
 * registry — l'Outlet (qui retourne null) sert juste à valider le contrat.
 */

import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const candidateResultsRoutes: RouteObject[] = [
  {
    path: 'user-tests',
    Component: Outlet,
    handle: { context: CONTEXTS.CANDIDATE_RESULTS, title: 'Mes résultats' },
  },
  {
    path: 'user-tests/:userTestId',
    Component: Outlet,
    handle: { context: CONTEXTS.CANDIDATE_RESULTS, title: 'Résultats du test' },
  },
];

/** Route publique — accessible sans authentification. */
export const candidateResultsPublicRoutes: RouteObject[] = [
  {
    path: 'tests/:testId/evaluation/:evaluationId/attempt/:attemptId',
    Component: Outlet,
    handle: { context: CONTEXTS.TECH_TEST_RESULTS, title: "Résultats d'évaluation" },
  },
];
